import React from "react";
import { cn } from "@penmate/react-shared/lib/utils";

// Minimal form primitives for the flow. Local to this bundle until a second
// bundle needs them. Inputs are 17px on purpose — below 16px, iOS webviews
// zoom the viewport on focus.
//
// Search terms are typed as `type="search"`: Chrome on Android ignores
// autocomplete="off" on name-shaped fields and raises its autofill accessory
// strip over the keyboard — and can leave the strip's height allocated after
// the keyboard goes, pushing the page up off the bottom of the screen. Its
// classifier leaves search fields alone. The styles reset the search look.

export const Label = ({ className, ...props }: React.LabelHTMLAttributes<HTMLLabelElement>) => (
  <label
    className={cn("mb-1.5 block text-sm font-semibold text-foreground", className)}
    {...props}
  />
);

export const TextInput = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        "h-[52px] w-full rounded-xl px-4 text-[17px] text-foreground transition-shadow placeholder:text-muted-foreground/70",
        className,
      )}
      {...props}
    />
  ),
);
TextInput.displayName = "TextInput";

export const Select = React.forwardRef<HTMLSelectElement, React.SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, children, ...props }, ref) => (
    <div className="relative">
      <select
        ref={ref}
        className={cn(
          "h-[52px] w-full appearance-none rounded-xl px-4 pr-10 text-[17px] text-foreground transition-shadow",
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <svg
        className="pointer-events-none absolute right-4 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground"
        viewBox="0 0 16 16"
        fill="none"
        aria-hidden="true"
      >
        <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  ),
);
Select.displayName = "Select";
